<div class="property-details" [class.luxury]="listing.isLuxury && isListingDetails" [class.commercial]="listing.isCommercial">
  <ng-container *ngIf="!listing.isCommercial">
    <span class="detail">
      <span class="bold">{{listing.beds ? (listing.beds | number:'1.0-2') : ('na' | translate)}}</span>
      <span class="classifier" translate="property-details.beds"></span>
    </span>
      <span class="divider">|</span>
      <span class="detail">
      <span class="bold">{{listing.totalBaths ? (listing.totalBaths | number:'1.0-2') : ('na' | translate)}}</span>
      <span class="classifier" translate="property-details.baths"></span>
    </span>
      <span class="divider">|</span>
      <span class="detail">
      <span class="bold">{{listing.sqFt > 0 ? listing.sqFt : ('na' | translate)}} </span>
      <span class="classifier" translate="property-details.sqft"></span>
    </span>
  </ng-container>
  <ng-container *ngIf="listing.isCommercial">
    <ng-container *ngIf="!listing.isFarm">
      <span>
        <span class="detail">
          <span class="bold">{{listing.sqFt > 0 ? listing.sqFt : ('na' | translate)}} </span>
          <span class="classifier" translate="property-details.sqft"></span>
        </span>
      </span>
    </ng-container>
    <ng-container *ngIf="listing.isFarm">
      <span class="detail">
        <span class="bold">{{listing.lotSize > 0 ? listing.lotSize : ('na' | translate)}}</span>
        <span class="classifier" translate="property-details.acreage"></span>
      </span>
    </ng-container>
    <ng-container *ngIf="listing.primaryBusinessType">
      <span class="detail">
        <span class="divider">|</span>
        <span class="classifier">{{listing.primaryBusinessType}}</span>
      </span>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="listing.isCondo; else townhouseTemplte">
    <span class="divider">|</span>
    <span class="detail">
      <span class="classifier" translate="property-details.condo"></span>
    </span>
  </ng-container>
  <ng-template #townhouseTemplte>
    <ng-container *ngIf="listing.isTownhouse">
      <span class="divider">|</span>
      <span class="detail">
        <span class="classifier" translate="property-details.townhouse"></span>
      </span>
    </ng-container>
  </ng-template>
  <ng-container *ngIf="listing.isHouse">
    <span class="divider">|</span>
    <span class="detail">
      <span class="classifier" translate="property-details.house"></span>
    </span>
  </ng-container>
</div>
